import { withFormik } from 'formik';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { History } from 'history';
import { AppThunk } from '../../../app/store';
import { AddOrEditCounselorForm } from './AddOrEditCounselorForm';
import {
  ABOUT_REQUIRED,
  ADDRESS_REQUIRED,
  CITY_REQUIRED,
  COUNTRY_REQUIRED,
  EMAIL_INVALID,
  EMAIL_NOT_LONG_ENOUGH,
  EMAIL_REQUIRED,
  NAME_REQUIRED,
  POSTAL_CODE_REQUIRED,
  REFERENCE_CODE_REQUIRED,
  SCHOOL_NAME_REQUIRED,
  STREET_REQUIRED,
} from '../../../constants/formMessages';
import { createCounselorAsProgramManager } from '../../../slices/counselorSlice';

interface IDispatchProps {
  createCounselorAsProgramManager: (
    name: string,
    email: string,
    schoolName: string,
    referenceCode: string,
    address: string,
    street: string,
    city: string,
    state: string,
    country: string,
    postalCode: number,
    about: string,
    history: History
  ) => AppThunk;
}

export interface EnhancedAddOrEditCounselorFormValues {
  name: string;
  email: string;
  schoolName: string;
  referenceCode: string;
  address: string;
  street: string;
  city: string;
  state: string;
  country: string;
  postalCode: number;
  about: string;
}

export interface EnhancedAddOrEditCounselorFormProps
  extends RouteComponentProps {
  name?: string;
  email?: string;
  schoolName?: string;
  referenceCode?: string;
  address?: string;
  street?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: number;
  about?: string;
  createCounselorAsProgramManager: (
    name: string,
    email: string,
    schoolName: string,
    referenceCode: string,
    address: string,
    street: string,
    city: string,
    state: string,
    country: string,
    postalCode: number,
    about: string,
    history: History
  ) => void;
}

const EnhancedAddOrEditCounselorForm = withFormik<
  EnhancedAddOrEditCounselorFormProps,
  EnhancedAddOrEditCounselorFormValues
>({
  mapPropsToValues: (props) => ({
    name: props.name ? props.name : '',
    email: props.email ? props.email : '',
    schoolName: props.schoolName ? props.schoolName : '',
    referenceCode: props.referenceCode ? props.referenceCode : '',
    address: props.address ? props.address : '',
    street: props.street ? props.street : '',
    city: props.city ? props.city : '',
    state: props.state ? props.state : '',
    country: props.country ? props.country : '',
    postalCode: props.postalCode ? props.postalCode : 0,
    about: props.about ? props.about : '',
  }),
  validationSchema: Yup.object().shape({
    name: Yup.string().required(NAME_REQUIRED),
    email: Yup.string()
      .min(3, EMAIL_NOT_LONG_ENOUGH)
      .max(255)
      .email(EMAIL_INVALID)
      .required(EMAIL_REQUIRED),
    referenceCode: Yup.string().notRequired(),
    address: Yup.string().notRequired(),
    street: Yup.string().notRequired(),
    city: Yup.string().notRequired(),
    country: Yup.string().notRequired(),
    postalCode: Yup.number().notRequired(),
    about: Yup.string().notRequired(),
  }),
  handleSubmit: (values, { setSubmitting, props }) => {
    const { history, createCounselorAsProgramManager } = props;
    const {
      name,
      email,
      schoolName,
      referenceCode,
      address,
      street,
      city,
      state,
      country,
      postalCode,
      about,
    } = values;
    createCounselorAsProgramManager(
      name,
      email,
      schoolName,
      referenceCode,
      address,
      street,
      city,
      state,
      country,
      postalCode,
      about,
      history
    );
    setSubmitting(false);
  },
  displayName: 'BasicForm',
})(AddOrEditCounselorForm);

const EnhancedAddOrEditCounselorFormWithRouter = withRouter(
  EnhancedAddOrEditCounselorForm
);

export default connect<null, IDispatchProps>(null, {
  createCounselorAsProgramManager,
})(EnhancedAddOrEditCounselorFormWithRouter);
